import React from 'react';
function Home() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-2 bg-gray-50">
      <h1 className="text-xl font-bold text-center text-gray-800 mb-3">Bienvenue !</h1>
      <p className="text-sm text-gray-600 text-center max-w-prose">
        Soumettez, suivez et gérez vos demandes facilement à partir d’un seul endroit.
      </p>
    </div>
  );
}

export default Home;
